import { ReportSettings, ReportType, ReportTypes } from './reportSettings.ts';
import { InfoIcon } from '../../../components/dialog-portal/infoIcon.tsx';
import { PeriodOptionSet } from '../period-selection/createPeriodOptions.ts';
import { getDefaultPeriodRange } from '../period-selection/defaultPeriodRange.ts';
import { findPeriodRangeForDates } from '../period-selection/periodRanges.ts';

interface Props {
    reportSettings: ReportSettings;
    setReportSettings: (reportSettings: ReportSettings) => void;
    periodOptionSet: PeriodOptionSet;
    onShowReportTypeInfo: () => void;
}

export function ReportTypeControl({
    reportSettings,
    setReportSettings,
    periodOptionSet,
    onShowReportTypeInfo,
}: Props) {
    function handleReportTypeSelect(reportType: ReportType) {
        if (reportType !== 'Setups') {
            setReportSettings({ ...reportSettings, reportType });
            return;
        }
        // Setups select dates by day without grouping the graph into periods.
        const days = periodOptionSet.days;
        const range = findPeriodRangeForDates(
            days,
            reportSettings.first.start,
            reportSettings.last.end,
        );
        const dateSettings = range ? {
            first: days[range.firstIndex],
            last: days[range.lastIndex],
            periodsInRange: days.slice(range.firstIndex, range.lastIndex + 1),
        } : getDefaultPeriodRange(periodOptionSet, 'Days');
        setReportSettings({
            ...reportSettings,
            ...dateSettings,
            reportType,
            resolution: 'Days',
        });
    }

    return (
        <section className='report-controls__section'>
            <div className='report-controls__heading'>
                <span>Report type</span>
                <InfoIcon onClick={onShowReportTypeInfo} title='About report types' />
            </div>
            <div className='report-controls__report-list'>
                {ReportTypes.map((value) => (
                    <button
                        key={value}
                        type='button'
                        className={reportSettings.reportType === value ? 'selected' : undefined}
                        aria-pressed={reportSettings.reportType === value}
                        onClick={() => handleReportTypeSelect(value)}
                    >
                        {value}
                    </button>
                ))}
            </div>
        </section>
    );
}
